module.exports = __webpack_public_path__ + "static/forecast/weather/daythunderstorm-651f1b4f4db894a238cd3cf59b3348b5.svg";